import { render } from "./TransactionsConfiguration.vue?vue&type=template&id=61b29032&scoped=true"
import script from "./TransactionsConfiguration.vue?vue&type=script&lang=js"
export * from "./TransactionsConfiguration.vue?vue&type=script&lang=js"

import "./TransactionsConfiguration.vue?vue&type=style&index=0&id=61b29032&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b29032"]])

export default __exports__